import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { Languages } from './languages.es.js';

var _GuestSitePricingTabs, _GuestSitePricingLink, _GuestSiteDistributio;
var Links = /*#__PURE__*/function (Links) {
  Links["Library"] = "/library";
  Links["Projects"] = "/projects";
  Links["Releases"] = "/releases/overview";
  Links["ReleasesCatalog"] = "/releases/catalog";
  Links["Account"] = "/account";
  Links["AccountGeneralSettings"] = "/account/settings";
  Links["AccountPlansAndCredits"] = "/account/plans";
  Links["AccountBilling"] = "/account/billing";
  Links["Pricing"] = "/pricing";
  Links["PricingMastering"] = "/pricing/master";
  Links["PricingDistribution"] = "/pricing/release";
  Links["PricingSessions"] = "/pricing/sessions";
  Links["PricingSamples"] = "/pricing/samples";
  Links["Sessions"] = "/sessions";
  Links["Feedback"] = "/feedback";
  Links["Messages"] = "/messages";
  Links["MessagesNew"] = "/messages/to";
  Links["Creator"] = "/creator-beatmaker";
  Links["Plugins"] = "/plugins";
  Links["Education"] = "/education";
  Links["MyPlugins"] = "/my-account/orders";
  Links["Connections"] = "/connections?tab=connections";
  Links["Users"] = "/connections/users";
  Links["Pros"] = "/browse/pros";
  Links["BecomePro"] = "/become-a-pro";
  Links["CollabGuestPage"] = "/music-collaboration";
  Links["MyOrders"] = "/orders?tab=requested";
  Links["Orders"] = "/network/orders";
  Links["Assignments"] = "/network/assignments";
  Links["Quotes"] = "/network/quotes";
  Links["MyAssignments"] = "/assignments?tab=requested";
  Links["MyProfile"] = "/users/me";
  Links["Referrals"] = "/referrals";
  Links["CommunityChannels"] = "/community-channels";
  Links["ReleasesList"] = "/releases/list";
  Links["SamplesDownloads"] = "/downloads";
  Links["DesktopAppInstallerPage"] = "/my-account/view-order/?pid=de50d9c9-d2ae-4e6b-911d-54954e8a24fe";
  return Links;
}({});
var PricingTabs = /*#__PURE__*/function (PricingTabs) {
  PricingTabs["AllAccess"] = "AllAccess";
  PricingTabs["Mastering"] = "Mastering";
  PricingTabs["Distribution"] = "Distribution";
  PricingTabs["Samples"] = "Samples";
  PricingTabs["Sessions"] = "Sessions";
  return PricingTabs;
}({});
var WebAppPricingTabs = {
  AllAccess: '/studio',
  Mastering: '/master',
  Distribution: '/release',
  Samples: '/samples',
  Sessions: '/sessions'
};
var GuestSitePricingTabs = (_GuestSitePricingTabs = {}, _defineProperty(_GuestSitePricingTabs, Languages.English, {
  AllAccess: '/studio',
  Mastering: '/master',
  Distribution: '/release',
  Samples: '/samples-en',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.French, {
  AllAccess: '/studio',
  Mastering: '/masteriser',
  Distribution: '/distribution',
  Samples: '/samples-fr',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.German, {
  AllAccess: '/studio',
  Mastering: '/mastern',
  Distribution: '/vertrieb',
  Samples: '/samples-de',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.Italian, {
  AllAccess: '/studio',
  Mastering: '/masterizza',
  Distribution: '/pubblicazioni',
  Samples: '/samples-it',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.Japanese, {
  AllAccess: '/studio',
  Mastering: '/マスタリンクと',
  Distribution: '/リリース',
  Samples: '/samples-jp',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.Portuguese, {
  AllAccess: '/studio',
  Mastering: '/masterize',
  Distribution: '/lancamento',
  Samples: '/samples-pt',
  Sessions: '/sessions'
}), _defineProperty(_GuestSitePricingTabs, Languages.Spanish, {
  AllAccess: '/studio',
  Mastering: '/masterizacion',
  Distribution: '/distribucion',
  Samples: '/samples-es',
  Sessions: '/sessions'
}), _GuestSitePricingTabs);
var GuestSitePricingLinks = (_GuestSitePricingLink = {}, _defineProperty(_GuestSitePricingLink, Languages.English, '/pricing'), _defineProperty(_GuestSitePricingLink, Languages.French, '/fr/tarifs'), _defineProperty(_GuestSitePricingLink, Languages.German, '/de/preise'), _defineProperty(_GuestSitePricingLink, Languages.Italian, '/it/tariffe'), _defineProperty(_GuestSitePricingLink, Languages.Japanese, '/ja/料金'), _defineProperty(_GuestSitePricingLink, Languages.Portuguese, '/pt/preco'), _defineProperty(_GuestSitePricingLink, Languages.Spanish, '/es/precios'), _GuestSitePricingLink);
var GuestSiteDistributionTab = (_GuestSiteDistributio = {}, _defineProperty(_GuestSiteDistributio, Languages.English, '/digital-distribution'), _defineProperty(_GuestSiteDistributio, Languages.French, '/fr/distribution-digitale'), _defineProperty(_GuestSiteDistributio, Languages.German, '/de/digitaler-musikvertrieb'), _defineProperty(_GuestSiteDistributio, Languages.Italian, '/it/distribuzione-digitale'), _defineProperty(_GuestSiteDistributio, Languages.Japanese, '/ja/テシタル音楽配信'), _defineProperty(_GuestSiteDistributio, Languages.Portuguese, '/pt/distribuicao-digital'), _defineProperty(_GuestSiteDistributio, Languages.Spanish, '/es/distribucion-digital'), _GuestSiteDistributio);

export { GuestSiteDistributionTab, GuestSitePricingLinks, GuestSitePricingTabs, Links, PricingTabs, WebAppPricingTabs };
